import {createReducer, on} from "@ngrx/store";
import * as UtilitiesOnlineActions from "./utilities-online.actions";
import {MyBillsModel} from '../../_models/utilities-online.models';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const utilitiesOnlineFeatureKey = 'utilitiesOnline';

export interface UtilitiesOnlineState {
    data: MyBillsModel,
    listLoading: DahLoadingType
}

export const initialState: UtilitiesOnlineState = {
    data: {},
    listLoading: 'listLoading' as DahLoadingType,
};

export const utilitiesOnlineReducer = createReducer(
    initialState,

    on(UtilitiesOnlineActions.load, (state) => ({
        ...state,
        listLoading: state.data?.apartments ? undefined : 'listLoading' as DahLoadingType,
    })),

    on(UtilitiesOnlineActions.loadSuccess, (state, payload) => ({
        ...state,
        data: payload.data,
        listLoading: undefined,
    })),

    on(UtilitiesOnlineActions.loadFailure, (state) => ({
        ...state,
        listLoading: undefined,
    })),

    on(SetAllInitialStates, () => ({...initialState}))
);
